import React from "react";
import { useContentContext } from "./Content";

import styles from "./Content.module.css";

/**
 * @visibleName Content.Info
 */
const ContentInfo = ({ children }) => {
    // eslint-disable-next-line no-unused-vars
    const _ = useContentContext();

    return <div className={styles.info}>{children}</div>;
};

export default ContentInfo;
